import { Route } from "next";

export const paths = {
  home: "/",
  about: "/about",
  activities: "/activities",
  team: "/team",
  teamId: (id) => `/team/${id}` as Route,
  testimonials: "/testimonials",
  blog: "/blog",
  blogId: (id) => `/blog/${id}` as Route,
  resources: "/resources",
  contact: "/contact",
} satisfies Record<string, Route | ((arg: string | number) => Route)>;
